import { LoadingButton } from '@mui/lab'
import { styled } from '@mui/material'

export const Button = styled(LoadingButton)`
  height: 4rem;
  font-size: 1.5rem;

  background-color: #bdbdbd; /* grey-dark */
  &:hover {
    background-color: #3d3d3d; /* black-light */
  }
`
